export default "__VITE_ASSET__4ac4a6b6__"